import React, { useState, useEffect, useRef , useCallback} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ReactTabulator } from 'react-tabulator';
import {Card} from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { jwtDecode } from 'jwt-decode';
import moment from 'moment';
import "react-datepicker/dist/react-datepicker.css";
import "tabulator-tables/dist/css/tabulator_semanticui.min.css"; 
import loader from '../../assets/img/loading.gif'
import API from '../../api/api.jsx';
import Base_003_01 from './base_003_01'
import { API_BASE_URL } from '../../config/app-axios.jsx';
import { clearUserState } from '../../reducers/userReducers.jsx';
import { clearMenuState } from '../../reducers/menuReducers.jsx';
import { clearLangCodeState } from '../../reducers/langCodeReducers.jsx';
import { getUserInfo } from '../../reducers/selectors/selectors.jsx';
import { store } from '../../store.jsx';

// 직원관리 화면
const Base003 = () => {
	const { t,i18n }  = useTranslation();
	const dispatch    = useDispatch();
	const tableRef    = useRef(null);

	// 초기 값
	const [loading, setLoading]           = useState(false);
	const [userSeq, setUserSeq]           = useState('');
	const [userName, setUserName]         = useState('');   
	const [rowsPerPage, setRowsPerPage]   = useState(20);
	const [filterField, setFilterField]   = useState('name');
	const [filterType, setFilterType]     = useState('like');
	const [filterValue, setFilterValue]   = useState('');
	const [detailData, setDetailData]     = useState([]);	// 단건
	const [totalCount, setTotalCount]     = useState(0);
	
	// 모달폼오픈
	const [showModal, setShowModal] = useState(false);

	const [SelectOptions1,setSelectOptions1]  = useState([]);   // 지점
	const [SelectOptions2,setSelectOptions2]  = useState([]); 	// 권한
	const [SelectOptions3,setSelectOptions3]  = useState([]);	// 상태
	const [SelectOptions4,setSelectOptions4]  = useState([]);	// 다국어

	// remote 방식에 따른 페이징 처리
	const apiUrl                                      = API_BASE_URL;
	const userInfo                                    = getUserInfo(store.getState());
	const [branchType, setBranchType]                 = useState(userInfo.branch_type);
	const token                                       = userInfo?.access_token;
	const [selectBranch,setSelectBranch]              = useState('');
	const [selectOptions,setSelectOptions]            = useState([]);

	// 지점 정보 변경
	const handleChangeBranch = (e) => {
		setSelectBranch(e.target.value);
	};

	// ①. 강제로 쿠키 삭제를 통한 로그인 정보가 없는 경우
    const persistInfo = sessionStorage.getItem('persist:login');

    if (!persistInfo) {
        window.location.href = '/login';
    };

	// ②. 토큰 만료 체크 루틴
	if (token) {
		const decodedToken            = jwtDecode(token);
		const expirationTimeInSeconds = decodedToken.exp;
		const currentTimeInSeconds    = Math.floor(Date.now() / 1000);

		if (expirationTimeInSeconds < currentTimeInSeconds) {
			// 토큰이 만료되었을 경우 로그인 페이지로 리디렉션
			dispatch(clearUserState());
			dispatch(clearMenuState());
			dispatch(clearLangCodeState());
			localStorage.removeItem('langCodeInfo');
			window.location.href = '/login';
		};
	};

	// i18 선택된 언어에 따라 필요한 필드 값 번역
	const translateItem = useCallback((item, language) => ({
		...item,
		status    : item.status ? t(`USER_STATUS.${item.status}`, { lng: language }) : '',
		authority : item.authority ? t(`AUTHORITY.${item.authority}`, { lng: language }) : '',
	}), [t]);

	useEffect(() => {
		const fetchBaseOptions = async () => {
			try {
				const data = await API.fetchBaseOptions();

				//첫 화면에 보이는 지점select
				const options  = data.filter(item => item.code_nick_name === '지점');
				const SelectOptions = options.map(item => [item.code,item.code_se]);
				
				setSelectOptions(SelectOptions);
				
				if (SelectOptions.length === 1) {
					setSelectBranch(SelectOptions[0][0]);
				};

				const options1  = data.filter(item => item.code_nick_name === '지점');
				const SelectOptions1 = options1.map(item => [item.code,item.code_se]);
				
				setSelectOptions1(SelectOptions1);

				
				const options2 = data.filter(item => item.code_nick_name === '사용자권한');
				const SelectOptions2 = options2.map(item => [item.code,item.code_se]);
				
				setSelectOptions2(SelectOptions2);
				
				const options3 = data.filter(item => item.code_nick_name === '사용자상태');
				const SelectOptions3 = options3.map(item => [item.code,item.code_se]);
				
				setSelectOptions3(SelectOptions3);
				
				const options4 = data.filter(item => item.code_nick_name === '다국어');
				const SelectOptions4 = options4.map(item => [item.code, item.code_se]);
				setSelectOptions4(SelectOptions4);
			} catch (error) {
				console.error('Error fetching data:', error);
			}
		};

		fetchBaseOptions();
	}, []); // 빈 배열은 컴포넌트가 마운트될 때 한 번만 실행

	// Tabulator Options
	// options 객체를 상태로 관리
	const [options, setOptions] = useState({
		ajaxURL     : `${apiUrl}/base/base_003`,
		ajaxConfig  : {
			method  : 'GET',
			headers : {
				'Content-Type' : 'application/json',
				'Authorization': `Bearer ${token}`,
			},
		},
		ajaxParams : {
			UserSeq     : userSeq, 
			UserName    : userName,
			branch_code : selectBranch,
			page        : tableRef.current && tableRef.current.table ? tableRef.current.getPage() : 1,
			size        : tableRef.current && tableRef.current.table ? tableRef.current.getPageSize() : 20, // 페이지 크기 정보
		},
		layout                 : "fitColumns",
		pagination             : true,
		paginationMode         : "remote",
		paginationSize         : rowsPerPage,
		paginationSizeSelector : [20, 40, 60, 80, 100],
		ajaxResponse : function (url, params, response) {

			const total_count    = response.total_count || 0;
			const translatedData = response.data.map(item => translateItem(item, i18n.language));
			const responseData   = {
				last_page : response.last_page,
				data      : translatedData,
			};

			setTotalCount(total_count);

			return responseData;
		}
	});

	// 로딩 중일 때 이전의 pagination 관련 정보를 유지하도록 설정
	const loadingOptions = {
		pagination             : true,
		paginationMode         : "remote",
		paginationSize         : rowsPerPage, // 이전 페이지 사이즈를 유지
		paginationSizeSelector : [20, 40, 60, 80, 100],
	};

	// 조회 버튼 작동 시 실행되는 함수
	const handleQuery = useCallback(
		async () => {
			setLoading(true);

			// ReactTabulator의 내부 로직을 사용하여 API 호출
			try {
				// ReactTabulator에서 사용하는 API URL과 Params를 사용하여 호출
				const url  = new URL(options.ajaxURL);
				url.search = new URLSearchParams({
					...options.ajaxParams,
					page         : tableRef.current?.getPage(),     // 현재 페이지 정보
					size         : tableRef.current?.getPageSize(), // 페이지 크기 정보
				});

				const data = await fetch(url, {
					method  : options.ajaxConfig.method,
					headers : options.ajaxConfig.headers,
				});

				const responseData = await data.json();

				// 전달 받은 총 데이터 건수
				const total_count = responseData.total_count || 0;
		
				// 번역이 필요한 부분
				const translatedData = responseData.data.map(item => translateItem(item, i18n.language));
		
				// 페이징 및 데이터 리턴
				const updatedData = {
					last_page  : responseData.last_page, // 전체 페이지 수 계산
					data       : translatedData,         // 실제 테이블 데이터				
				};

				// 총 건수를 화면에 표현하기 위해서
				setTotalCount(total_count);

				// 데이터 변경
				if (tableRef.current) {
					tableRef.current.setData(updatedData.data || []);
				}

				setLoading(false);

			} catch (error) {
				console.error('Error in fetchBase003Data : ', error);
				setLoading(false);
			} 
		}, [options, i18n.language, translateItem]
	);	

	// Cell 클릭 이벤트(수정)
	const handleCellClick = async (rowData) => {
		try {
			// ReactTabulator에서 사용하는 API URL과 Params를 사용하여 호출
			const url  = new URL(options.ajaxURL);
			url.search = new URLSearchParams({
				...options.ajaxParams,
				UserSeq      : rowData.user_seq,
				page         : tableRef?.current.getPage(),     // 현재 페이지 정보
				size         : tableRef?.current.getPageSize(), // 페이지 크기 정보
				branch_code   : selectBranch
			});

			const data = await fetch(url, {
				method  : options.ajaxConfig.method,
				headers : options.ajaxConfig.headers,
			});

			const responseData = await data.json();

			setDetailData(responseData.data)

			setLoading(false);

		} catch (error) {
			console.error('Error in fetchBase003UserDetail : ', error);
			setLoading(false);
		} 

		setShowModal(true);
	}

	const handleButtonClick = () => {
		setDetailData([]);
		setShowModal(true);
	}

	const handleClose = () => {
		setDetailData([]);
		setShowModal(false);
		handleQuery();
	}

	useEffect(() => {
		setColumns(titleColunms(t))
	}, [i18n.language, t]);

	// 조회 조건이 바뀜에 따라 ajaxParams 동적 변경
	useEffect(() => {
		setOptions((prevOptions) => {
			const updatedOptions = {
				...prevOptions,
				ajaxParams: {
					...prevOptions.ajaxParams,
					branch_code             : selectBranch
				},
			};
			return updatedOptions;
		});
	}, [selectBranch]);


	// Tabulator columns 목록
	const titleColunms = (t) => {
		return [
			{formatter:"rowSelection", titleFormatter:"rowSelection", headerHozAlign: 'center', hozAlign:"center", headerSort:false, width:30, cellClick:function(e, cell){
				cell.getRow().toggleSelect();
			}},
			{ title: t('STAFF_MANAGEMENT.성명', { defaultValue: '성명' }), field: 'name', headerHozAlign: 'center', hozAlign: 'center', width:120 },
			{ title: t('STAFF_MANAGEMENT.휴대폰번호', { defaultValue: '휴대폰번호' }), field: 'phone_number', headerHozAlign: 'center', hozAlign: 'center', width: 120 },
			{ title: t('STAFF_MANAGEMENT.등록일', { defaultValue: '등록일' }), field: 'created_date', headerHozAlign: 'center', hozAlign: 'center', width:180, formatter:function(cell, formatterParams, onRendered){
				var value = cell.getValue();
				value = moment(value).format("DD/MM/YYYY HH:mm:ss");
				return value;
			} },
			{ title: `<i class="fa-solid fa-link"></i> ${t('STAFF_MANAGEMENT.아이디', { defaultValue: '아이디' })}`, field: 'user_id', headerHozAlign: 'center', hozAlign: 'center', width:200 ,
				formatter: function (cell, formatterParams, onRendered) {
					cell.getElement().style.fontWeight = 'bold';
					cell.getElement().style.color = 'green';
					return cell.getValue();
				},
				cellClick:function(e, cell){
					const rowData = cell.getRow().getData();
					handleCellClick(rowData);
				},
			},
			{ title: t('STAFF_MANAGEMENT.상태', { defaultValue: '상태' }), field: 'status', headerHozAlign: 'center', hozAlign: 'center', width:160 },
			{ title: t('STAFF_MANAGEMENT.지점', { defaultValue: '지점' }), field: 'branch_name', headerHozAlign: 'center', hozAlign: 'center', width:200 },
			{ title: t('STAFF_MANAGEMENT.권한', { defaultValue: '권한' }), field: 'authority', headerHozAlign: 'center', hozAlign: 'center', width:200 },
			{ title: 'SEQ', field: 'use_seq', headerHozAlign: 'center', hozAlign: 'center', width:200 ,visible: false},
		];
	}

	const [columns, setColumns] = useState(titleColunms(t));

	// Filter 값에 따른 Tabulator 변화가 일어나는 함수
	const updateFilter = () => {
		if (tableRef.current) {
			tableRef.current.setFilter(filterField, filterType, filterValue);
		}
	};

	// value값을 입력할 때마다 해당되는 Tabulator가 화면에 보이도록 함수호출하는 부분
	const handleKeyUp = () => {
		updateFilter();
	};

	// UI
	return (
		<Card style={{ height: '100%' }}>
			<Card.Header><strong>{t('MENU_I18N.직원관리', { defaultValue: '직원관리' })}</strong></Card.Header>
			<Card.Body className='responsive-card-body'>
				<div className="panel-body">
					{/* <form action="/" method="POST"> */}
						<div className="row ms-0">
							<div className="form-group col-lg-2 col-md-12 col-xs-12 mb-2 ps-0 rounded-2">
								<label className="form-label" htmlFor="acct_nickname_id">
									<i className="bi bi-pen"></i> {t('LOAN_APPLICATION.지점', { defaultValue: '지점' })}
								</label>
								<select onChange={handleChangeBranch} value={selectBranch} className="form-select" id="site_code_id">
									{branchType === 'HEAD' 
										? <option value="">{t('COMMON.전체', { defaultValue: '전체' })}</option>
										: ''
									}
									{selectOptions.map((option, index) => (
										<option key={index} value={option[0]}>
											{/* {t(`${option[1]}.${option[0]}`, { defaultValue: `${option[0]}` })} */}
											{option[1]}											
										</option>
									))}
								</select>
							</div>

							<div className="form-group col-lg-4 col-md-12 col-xs-12"></div>
							<div className="form-group col-lg-5 col-md-12 col-xs-12"></div>

							<div className="form-group col-lg-1 col-md-12 col-xs-12 ps-0 rounded-2">
								<div className="mb-3"></div>
								<button type="button" className="btn btn-success float-end float-bottom w-100 h-30.5px align-baseline mt-8px" onClick={handleQuery}>{t('LOAN_APPLICATION.조회', { defaultValue: '조회' })}</button>
							</div>

							<div className="mt-3 mb-3 ps-0">
								<i id="filter-icon" className="cursor-pointer fa fa-plus-square" data-bs-toggle="collapse" href="#collapseExample" aria-expanded="false" aria-controls="collapseExample"></i>
								<span> Filter</span>
							</div>

							<div className="collapse show" id="collapseExample">
								<div className="row">
									<div className="form-group col-lg-2 col-md-12 col-xs-12 ps-0 rounded-2 mb-1">
										<select 
											id="filter-field" 
											className="form-select col-sm-3" 
											value={filterField}
											onChange={(e) => setFilterField(e.target.value)}
										>
											<option value="name">{t('STAFF_MANAGEMENT.성명', { defaultValue: '성명' })}</option>
											<option value="phone_number">{t('STAFF_MANAGEMENT.휴대폰번호', { defaultValue: '휴대폰번호' })}</option>
											<option value="user_id">{t('STAFF_MANAGEMENT.아이디', { defaultValue: '아이디' })}</option>
											<option value="authority">{t('STAFF_MANAGEMENT.권한', { defaultValue: '권한' })}</option>											
										</select>
									</div>
						
									<div className="form-group col-lg-2 col-md-12 col-xs-12 ps-0 rounded-2 mb-1">
										<select 
											id="filter-type" 
											className="form-select col-sm-3"
											value={filterType}
											onChange={(e) => setFilterType(e.target.value)}
										>
											<option value="like">LIKE</option>
											<option value="=">=</option>
											<option value="<">&lt;</option>
											<option value="<=">&le;</option>
											<option value=">">&gt;</option>
											<option value=">=">&ge;</option>
											<option value="!=">!=</option>
										</select>
									</div>
						
									<div className="form-group col-lg-8 col-md-12 col-xs-12 ps-0 mb-3 rounded-2">
										<input 
											id="filter-value" 
											type="text" 
											className="form-control col-sm-6" 
											name="filter-value" 
											placeholder={t('COMMON.검색할 내용을 입력하세요', { defaultValue: '검색할 내용을 입력하세요' })}
											value={filterValue}
											onChange={(e) => setFilterValue(e.target.value)}
											onKeyUp={handleKeyUp}
										/>
									</div>
								</div>
							</div>
						</div>
					{/* </form> */}
				</div>

				{/* 로딩 관련 gif */}
				{loading && 
					<div
						style={{
							position: 'fixed',
							top: '50%',
							left: '55%',
							transform: 'translate(-50%, -50%)',
							zIndex: 9999,
						}}
					>
						<img src={loader} alt="Loading..." />
					</div>
				}

				{/* Tabulator */}
				<div id="tabulator-total-info" className='d-flex justify-content-end fw-bold'>{t(`LOAN_APPLICATION.총 {{count}}건`, { count: totalCount, defaultValue: '총 {{count}}건' })}</div>
				<ReactTabulator
					key         = {i18n.language + JSON.stringify(columns) + JSON.stringify(options)} // 언어 변경 및 옵션 변경에 따라 컴포넌트 리렌더링
					onRef       = {(r) => (tableRef.current = r.current)}
					columns     = {columns}
					options     = {loading ? loadingOptions : options} // 로딩 중일 때는 이전의 pagination 관련 정보를 유지하고 데이터를 변경하지 않도록 함
					placeholder = "No Data Found"
					className   = "responsive-tabulator"
				/>
			</Card.Body>

			<div className="card-footer d-flex justify-content-start mt-auto">
				<button type="button" className="btn btn-outline-info mb-1 me-1 w-auto" onClick={handleButtonClick}>{t('STAFF_MANAGEMENT.직원등록', { defaultValue: '직원등록' })}</button>
			</div>
			
			<Base_003_01 showModal={showModal} handleClose={handleClose} SelectOptions1={SelectOptions1} SelectOptions2={SelectOptions2} SelectOptions3={SelectOptions3} SelectOptions4={SelectOptions4} DetailData={detailData.length > 0 ? detailData[0] : null} />
		</ Card>
	);
};

export default Base003;